import { Component, input } from '@angular/core';

@Component({
  selector: 'oke-loader',
  imports: [],
  templateUrl: './loader.html',
  styleUrl: './loader.scss'
})
export class Loader {
  readonly $loadId = input<null | string>(null, {
    alias: 'loadId'
  });
}
